import { Button, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import PostAddIcon from '@material-ui/icons/PostAdd';
import { openModalVuelos } from "../../../ducks/proveedorTerrestreDuck"

const BVuelos = (props) => {
    const dispatch = useDispatch()
    const { paquete, disabled } = props

    const handleClick = () => {
        dispatch(openModalVuelos({
          paquete
        }))
    }

    return (
        <Tooltip title="Vuelos" disabled={disabled}>
            <Button onClick={handleClick} variant="contained" color="primary" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} disabled={disabled}>
               Vuelo <PostAddIcon color="white" style={{ marginLeft: "5px" }} />
            </Button>
        </Tooltip>
    )
}

export default BVuelos;